import styled from 'styled-components';
import theme from '../../feachers/theme';

export const Wrapper = styled.div``;

export const ContainerHead = styled.div`
  max-width: 1400px;
  margin: auto;
  position: relative;
  padding-bottom: 55px;
  text-align: center;
  
  @media screen and ${theme.breakpoints.screenMd} {
    padding-bottom: 0;
  }
`;

export const Subtitle = styled.h3`
  font-size: 22px;
  color: #787d2f;
  font-family: 'Mix Pudgy Panda';
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1px;
  opacity: 0.75;
  padding-bottom: 10px;
`;

export const Icon = styled.div`
  position: absolute;
  left: 0;
  top: 25px;
  width: 133px;
  height: 179px;

  img {
    display: block;
  }

  @media screen and ${theme.breakpoints.screenMd} {
    display: none;
  }
`;

export const ContainerList = styled.ul`
  display: flex;
  gap: 30px;
  width: 100%;
  justify-content: center;
  padding: 0;
  padding-bottom: 30px;
  margin-bottom: 0;
  overflow-y: auto;

  @media screen and ${theme.breakpoints.screenLg} {
    width: auto;
    justify-content: initial;
    margin: 0;
    padding: 0 20px;
  }
`;

export const ProductListWrapper = styled.div`
  padding: 40px 0;
  border-radius: 20px;
  margin-bottom: 40px;
  overflow: hidden;

  @media screen and ${theme.breakpoints.screenMd} {
    margin-left: -20px;
    margin-right: -20px;
    padding: 30px 0;
  }
`;

export const ProductListTitle = styled.h3`
  margin-top: 0;
  padding: 0px;
  color: #333300;
  text-align: center;
  font-family: Mix Pudgy Panda;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 1.5px;
  text-transform: uppercase;

  @media screen and ${theme.breakpoints.screenMd} {
    font-size: 28px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;

  @media screen and ${theme.breakpoints.screenMd} {
    flex-wrap: nowrap;
    overflow-y: hidden;
    justify-content: initial;
    white-space: nowrap;
    padding: 0 10px 10px;
    margin: 0 -20px 30px;
  }
`;

export const FilterBtn = styled.button<{ active: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 10px 25px;
  border-radius: 40px;
  border: 1px solid #878a3e80;
  color: var(--color-grey-01);
  font-weight: var(--typeweight--default);
  font-family: inherit;
  font-size: var(--typesize--medium);
  line-height: 1.4;
  background-color: ${({ active }) => (active ? '#878a3e80' : '#ffffff')};
  cursor: pointer;
`;
